import { render, staticRenderFns } from "./PortalTopic.vue?vue&type=template&id=44fbd40d&lang=pug"
import script from "./PortalTopic.vue?vue&type=script&lang=js"
export * from "./PortalTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports